import request from '@/utils/request'; // 获取证件类型

export function getData() {
  return request({
    url: '/commondictionary/dictionary/queryByCodeType',
    method: 'post',
    data: {
      "codeType": "UserIdCard"
    }
  });
} // 注册

export function regist(data) {
  return request({
    url: '/ecargoaccount/user/regist',
    method: 'post',
    data: data
  });
} // 邮箱验证码

export function sendCheckCode(data) {
  return request({
    url: '/ecargoaccount/user/sendCheckCode',
    method: 'post',
    data: data
  });
} // 注册

export function registGetSingleLoginData(data) {
  return request({
    url: '/ecargoaccount/user/getSingleLoginData',
    method: 'post',
    data: data
  });
} // 上传营业执照

export function LicenseInfo(data) {
  return request({
    url: '/ecargoapis/business/LicenseInfo',
    method: 'post',
    data: data
  });
} // 查询投保人信息

export function getApplicantInfo(data) {
  return request({
    url: '/ecargoaccount/user/getSysUser',
    method: 'post',
    data: data
  });
} // 暂存/提交

export function saveApplicantInfo(data) {
  return request({
    url: '/ecargoprotocol/insure/Update',
    method: 'post',
    data: data
  });
} // 返回食品安全最低保费

export function getProtocolRateNumber(data) {
  return request({
    url: '/ecargoprotocol/insure/getProtocolRateNumber',
    method: 'post',
    data: data
  });
} // 查看/编辑 投被保人信息

export function seeApplicantInfo(data) {
  return request({
    url: '/ecargoprotocol/insure/Look',
    method: 'post',
    data: data
  });
}